exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".target__instructions {\n  margin-bottom: 20px; }\n\n.target__description {\n  margin-top: 20px;\n  user-select: none;\n  border: 1px solid #e9e9e9;\n  border-radius: 3px;\n  background-color: white;\n  padding: 5px 8px; }\n  .target__description .italic {\n    font-style: italic; }\n", ""]);

// exports
